
import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const optionStyles = makeStyles((theme: Theme) =>
  createStyles({
    rootContainer: {
      width: '100%',
      height: 'calc(88vh)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      paddingBottom: '2.5%',
      backgroundColor: '#F2F2F2',
    },
    "@keyframes fadeIn": {
      "0%": {
        opacity: 0,
      },
      "50%": {
        opacity: 1,
      },
      "100%": {
        opacity: 0,
      }
    },
    logo: {
      width: '250px',
      margin: '5% 0 8% 0',
      animation: "$fadeIn 3s infinite",
      [theme.breakpoints.down('sm')]: {
        width: '100px',
      },
    },
  }),
);
